import SyntheseEntityResistanceController from './syntheseentities.resistance.controller';

export default {
    template: require('./syntheseentities.resistance.html'),
    controller: SyntheseEntityResistanceController
};
